import { Injectable } from '@angular/core';
import { Router, RoutesRecognized } from '@angular/router';
import { filter, pairwise, Subject, Subscription } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class RouterEventsService {

  constructor(
    private router: Router
  ) {
  }

  private subscription: Subscription;
  previousRoute: string = '';
  currentRoute: string = '';

  subscribe() {
    this.subscription = this.router.events
      .pipe(filter((evt: any) => evt instanceof RoutesRecognized), pairwise())
      .subscribe((events: RoutesRecognized[]) => {
        this.previousRoute = events[0].urlAfterRedirects ?? '';
        this.currentRoute = events[1].urlAfterRedirects ?? '';
      });
  }

  unsubscribe() {
    this.subscription.unsubscribe();
  }
}
